import bus from '@services/bus';
import _ from 'lodash'

const HTTP_400 = 400;
const HTTP_404 = 404;
const HTTP_422 = 422;

export default {
    methods: {
        errorFeedback: (error, callback = null) => {
            const data = error.response.data

            if (error && error.response && error.response.status == HTTP_422) {
                if (typeof data == 'string') {
                    bus.$emit('feedback', {
                        size: 'small',
                        type: 'error',
                        message: data,
                        noFullscreen: true,
                        btnError: {
                            hide: true,
                        },
                    });
                } else if (typeof data == 'object' && (!_.isEmpty(data.errors) || !_.isEmpty(data))) {
                    let message = '';

                    let errors = data.errors || data;

                    Object.values(errors).forEach(error => {
                        message += ` ${error}`;
                    });

                    bus.$emit('feedback', {
                        size: 'small',
                        type: 'error',
                        message: message
                    });
                } else {
                    bus.$emit('feedback', {
                        type: 'error', message: 'Dados inválidos. Verifique o formulário.'
                    });
                }

                return HTTP_422;
            }

            if (error && error.response && error.response.status == HTTP_400) {
                bus.$emit('feedback', {
                    type: 'error',
                    message: typeof data == 'string'
                        ? data
                        : 'Ops, algo errado.'
                });

                return HTTP_400;
            }

            if (error && error.response && error.response.status == HTTP_404) {
                let message = typeof data == 'object'
                    ? (data.message ?? 'Não encontrado')
                    : 'Não encontrado'

                bus.$emit('feedback', {
                    type: 'error',
                    message: message
                });

                return HTTP_404;
            }

            if (callback) callback();
            else bus.$emit('feedback', { type: 'error', message: 'Ops, algo errado.' });

            return;
        },
    },
};
